import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const fileName = (t = "mappa") => t.replace(/[^\p{L}\p{N}]+/gu, "_").replace(/^_|_$/g, "").slice(0, 50) || "mappa";

export async function exportSheetPdf(el, title) {
  await document.fonts?.ready;
  for (let i = 0; i < 150 && el.querySelector("[data-img-loading]"); i++) await new Promise((r) => setTimeout(r, 100));
  await Promise.all([...el.querySelectorAll("img")].map((i) => (i.complete ? null : new Promise((r) => { i.onload = r; i.onerror = r; }))));
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
  const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pw = pdf.internal.pageSize.getWidth();
  const ph = pdf.internal.pageSize.getHeight();
  const r = Math.min(pw / canvas.width, ph / canvas.height);
  const w = canvas.width * r, h = canvas.height * r;
  pdf.addImage(canvas.toDataURL("image/jpeg", 0.95), "JPEG", (pw - w) / 2, (ph - h) / 2, w, h);
  pdf.save(`${fileName(title)}.pdf`);
}
